var exports = {
  "u": "section__XpqhPf",
};

module.exports = exports;
